/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Serializer for the internal representation of summary responses for text questions.
 */
export type InternalStudyTextQuestionSummary = {
    summary: string;
    /**
     * * `SUCCESS` - SUCCESS
     * * `FAILURE` - FAILURE
     */
    summaryType: InternalStudyTextQuestionSummary.summaryType;
    meta?: any;
};

export namespace InternalStudyTextQuestionSummary {

    /**
     * * `SUCCESS` - SUCCESS
     * * `FAILURE` - FAILURE
     */
    export enum summaryType {
        SUCCESS = 'SUCCESS',
        FAILURE = 'FAILURE',
    }


}

